import React, { useCallback, useEffect, useState } from "react";
import { object, string } from "prop-types";
import { get } from "lodash";
import { connect } from "react-redux";

import DfpContainer from "../../ads/dfp-container";
import { DfpComponent } from "../../ads/dfp-component";
import CloseIcon from "../../atoms/icons/close";

import { getSlotId } from "../../utils/utils";

import "./anchorAd.m.css";

const AnchorAd = ({ story, pageType, currentPath, lang, domainSlug }) => {
  const ads = {
    "home-page": {
      en: "EnPalo_HP_Floating_970x90",
      bn: "Mobile_HP_Anchor",
    },
    en: "EnPalo_Inner_Floating_970x90",
    bn: "Mobile_Article_Anchor",
  };

  const [showAnchorAd, setShowAnchorAd] = useState(false);
  const [stopScroll, setStopScroll] = useState(false);

  const shouldHideAnchor = domainSlug === "protichinta" || domainSlug === "trust" || pageType === "static-page";

  const scrollCallback = useCallback(() => {
    if (window.scrollY >= 400 && !stopScroll) {
      setShowAnchorAd(true);
      setStopScroll(true);
    }
  }, [stopScroll]);

  useEffect(() => {
    const footer = document.getElementById("footer");
    if (!footer) return;

    if (showAnchorAd && !shouldHideAnchor) {
      footer.classList.add("show-anchor");
    } else {
      footer.classList.remove("show-anchor");
    }
  }, [showAnchorAd, shouldHideAnchor]);

  useEffect(() => {
    document.addEventListener("scroll", scrollCallback);
    return () => document.removeEventListener("scroll", scrollCallback);
  }, [scrollCallback]);

  if (shouldHideAnchor || !showAnchorAd) return null;

  return (
    <DfpContainer>
      <div className="ad-bottom-container" styleName="ad-bottom show-ad">
        <div styleName="ad-bottom-wrapper">
          <div title="close" styleName="anchor-close" onClick={() => setShowAnchorAd(false)}>
            <CloseIcon />
          </div>

          <div styleName="ad-wrapper" className="adsBox">
            <DfpComponent
              targetStory={story}
              type={ads?.[pageType]?.[lang] || ads[lang]}
              slotId={getSlotId("anchor-ad", currentPath, story?.id)}
            />
          </div>
        </div>
      </div>
    </DfpContainer>
  );
};

AnchorAd.propTypes = {
  pageType: string,
  story: object,
  currentPath: string,
  lang: string,
  domainSlug: string,
};

const mapStateToProps = (state) => ({
  lang: get(state, ["qt", "config", "publisher-attributes", "lang"], ""),
  pageType: get(state, ["qt", "pageType"], ""),
  currentPath: get(state, ["qt", "currentPath"], ""),
  domainSlug: get(state, ["qt", "config", "domainSlug"], ""),
  story: state?.story?.story || state?.qt?.data?.story,
});

export default connect(mapStateToProps)(AnchorAd);
